 // Updated the SIP function to use async/await and added error handling - 15/10/24 - Dev Srini
const handleOutBoundHangup = async (dispatch) => {

    dispatch({
        type: 'SET_OUT_BOUND_CALLING',
        payload: true
    })

    try {
        await window.sipHangUp()
        console.log("SIP session hung up successfully.")
    } catch (error) {
        console.error('Failed to hang up SIP session:', error)
    }

}

export default handleOutBoundHangup